import { PageLayoutFooter } from '@angeplus/prever-component-lib';

import { TermsOfUse } from '../modules/terms/TermsOfUse';
import { PAGE_TITLE } from '../utils/pageTitle';

export default function TermsPage() {
  return (
    <PageLayoutFooter title={PAGE_TITLE.termsOfUse}>
      <TermsOfUse />
    </PageLayoutFooter>
  );
}
